<template>
  <div class="container text-center py-3">
    <h2>{{ $t('prices') }}</h2>
    <div>
      TODO
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    titleTemplate: "%s | Cijene",
    meta: [
      {
        name: "description",
        content:
          "Apartment Verano - Cijene",
      },
    ],
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/prices.vue